import React from 'react';
import { styled } from '../../../stitches.config';
import LazyLoad from "react-lazyload";

import Box from '../Box'
import { Wrapper as Wrap } from "./ACommonStyles"
import { getPcsUrls } from "./AHelpers"

export default props => {
	const size = window.innerWidth > 992 ? "sm" : "lg";
	const aspectRatio = { mobile: 0.92, desktop: 1.097 };
	const pcs = getPcsUrls(props.settings.settings?.pcs_background_mobile, props.settings.settings?.pcs_background_desktop);

	return (
		<section className="container">
			<Wrapper className="row" pcs={pcs}>
				<div className="col-xs-12 col-md-6">
					<Box {...props} id="b5" type="BTextOnPicture" settings={props.settings.b5} classes="" />
				</div>
				<div className="col-xs-12 col-md-3">
					<Box {...props} id="b1" type="BPhotoOnLeft" settings={props.settings.b1} classes="" />
					<Box {...props} id="b2" type="BPhotoOnLeft" settings={props.settings.b2} classes="" />
					<Box {...props} id="b3" type="BPhotoOnLeft" settings={props.settings.b3} classes="" />
					<Box {...props} id="b4" type="BPhotoOnLeft" settings={props.settings.b4} classes="" />
				</div>
				{/* #todo 4220 */}
				<div className="col-xs-12 col-md-3 column-wrapper">
					<Box {...props} id="b6" type="BPhotoOnTop" imageHeight={189} settings={props.settings.b6} size={size} classes="" />
					<LazyLoad height={300} offset={300}>
						<Box {...props} id="b7" type="AOnNetworkPlayer" settings={props.settings.b7} classes="" />
					</LazyLoad>
				</div>
			</Wrapper>
		</section>
	);
}

const Wrapper = styled(Wrap, {
	"@media (min-width: 992px)": {
		display: "flex",
		flexDirection: "row",
		"> div:nth-child(1)": { order: 2 },
		"> div:nth-child(2)": { order: 3 },
		"> div:nth-child(3)": { order: 1 },
		".column-wrapper": {
			display: "flex",
			flexDirection: "column",
			justifyContent: "space-between"
		}
	}
});
